import {
  UPLOAD_USER_SHOWCASE_FAILED,
  UPLOAD_USER_SHOWCASE_START,
  UPLOAD_USER_SHOWCASE_SUCCESS,
  FETCH_USER_SHOWCASE_START,
  FETCH_USER_SHOWCASE_SUCCESS,
  FETCH_USER_SHOWCASE_FAILED,
  DELETE_USER_SHOWCASE_START,
  DELETE_USER_SHOWCASE_SUCCESS,
  DELETE_USER_SHOWCASE_FAILED,
  DELETE_ALL_USER_SHOWCASE_START,
  DELETE_ALL_USER_SHOWCASE_SUCCESS,
  DELETE_ALL_USER_SHOWCASE_FAILED,
  FETCH_USER_SHOWCASE_START_ID,
  FETCH_USER_SHOWCASE_SUCCESS_ID,
  FETCH_USER_SHOWCASE_FAILED_ID,
  UPDATE_SHOWCASE_VISIBILITY,
  UPDATE_SHOWCASE_VISIBILITY_SUCCESS,
  UPDATE_SHOWCASE_VISIBILITY_FAILED,
  REQUEST_VISIBILITY_SHOWCASE,
  REQUEST_VISIBILITY_SHOWCASE_SUCCESS,
  REQUEST_VISIBILITY_SHOWCASE_FAILED,
  APPROVED_VISIBILITY_SHOWCASE,
  APPROVED_VISIBILITY_SHOWCASE_SUCCESS,
  APPROVED_VISIBILITY_SHOWCASE_FAILED,
  DECLINE_VISIBILITY_SHOWCASE,
  DECLINE_VISIBILITY_SHOWCASE_SUCCESS,
  DECLINE_VISIBILITY_SHOWCASE_FAILED

} from "../actions/ActionConstant";

export const initialState = {
  showcase: {
    data: [],
    loading: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
};

const showCaseReducer = (state = initialState, action) => {
  switch (action.type) {
    // Action for starting the upload of a user showcase
    case UPLOAD_USER_SHOWCASE_START:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          data: [],
          error: false,
          loading: true,
          buttonDisable: true,
          inputData: action.payload,
          loadingButtonContent: "Uploading...",
        },
      };

    // Action for successfully uploading a user showcase
    case UPLOAD_USER_SHOWCASE_SUCCESS:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          error: false,
          inputData: {},
          loading: false,
          data: [...state.showcase.data, ...action.payload],
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };

    // Action for failing to upload a user showcase
    case UPLOAD_USER_SHOWCASE_FAILED:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: false,
          inputData: {},
          error: action.error,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };

    // Action for starting the fetch of user showcase
    case FETCH_USER_SHOWCASE_START:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: true,
          error: false,
        },
      };

    // Action for successfully fetching user showcase
    case FETCH_USER_SHOWCASE_SUCCESS:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          data: action.payload,
          loading: false,
          error: false,
        },
      };

    // Action for failing to fetch user showcase
    case FETCH_USER_SHOWCASE_FAILED:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          data: [],
          loading: false,
          error: action.error,
        },
      };
    // Action for starting the fetch of user showcase by id
    case FETCH_USER_SHOWCASE_START_ID:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: true,
          error: false,
        },
      };

    // Action for successfully fetching user showcase
    case FETCH_USER_SHOWCASE_SUCCESS_ID:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          data: action.payload,
          loading: false,
          error: false,
        },
      };

    // Action for failing to fetch user showcase
    case FETCH_USER_SHOWCASE_FAILED_ID:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: false,
          data: [],
          error: action.error,
        },
      };

    // Action for starting the deletion of a user showcase
    case DELETE_USER_SHOWCASE_START:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: true,
        },
      };


    // Action for successfully deleting a user showcase
    case DELETE_USER_SHOWCASE_SUCCESS:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          data: state.showcase.data.filter(item => item.id !== action.payload),
          loading: false,
        },
      };

    // Action for failing to delete a user showcase
    case DELETE_USER_SHOWCASE_FAILED:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: false,
          error: action.error,
        },
      };

    // Action for starting the deletion of all user showcases
    case DELETE_ALL_USER_SHOWCASE_START:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: true,
        },
      };

    // Action for successfully deleting all user showcases
    case DELETE_ALL_USER_SHOWCASE_SUCCESS:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          data: [],
          loading: false,
        },
      };

    // Action for failing to delete all user showcases
    case DELETE_ALL_USER_SHOWCASE_FAILED:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: false,
          error: action.error,
        },
      };

    // Action for starting the Visibility of a user showcase
    case UPDATE_SHOWCASE_VISIBILITY:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: true,
        },
      };

    // Action for successfully VIsibility a user showcase
    case UPDATE_SHOWCASE_VISIBILITY_SUCCESS:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          data: state.showcase.data.map(item =>
            item.id === action.payload.id
              ? { ...item, ...action.payload } 
              : item
          )
      }};

    // Action for failing to Visibility a user showcase
    case UPDATE_SHOWCASE_VISIBILITY_FAILED:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: false,
          error: action.error,
        },
      }

      
    // Action for starting the Visibility Request of a user showcase
    case   REQUEST_VISIBILITY_SHOWCASE:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: true,
        },
      };

    // Action for successfully VIsibility Request a user showcase
    case REQUEST_VISIBILITY_SHOWCASE_SUCCESS:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: false
      }};

    // Action for failing to Visibility Request a user showcase
    case REQUEST_VISIBILITY_SHOWCASE_FAILED:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: false,
          error: action.error,
        },
      }

        
    // Action for starting the Visibility Approved of a user showcase
    case   APPROVED_VISIBILITY_SHOWCASE:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: true,
        },
      };

    // Action for successfully VIsibility Approved a user showcase
    case APPROVED_VISIBILITY_SHOWCASE_SUCCESS:
      return {
        ...state,       
          showcase: {
            ...state.showcase,
            loading: false
        }};

    // Action for failing to Visibility Approved a user showcase
    case APPROVED_VISIBILITY_SHOWCASE_FAILED:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: false,
          error: action.error,
        },
      }

      // Action for starting the Visibility Decline of a user showcase
    case DECLINE_VISIBILITY_SHOWCASE:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: true,
        },
      };

    // Action for successfully VIsibility Decline a user showcase
    case DECLINE_VISIBILITY_SHOWCASE_SUCCESS:
      return {
        ...state,       
          showcase: {
            ...state.showcase,
            loading: false
        }};

    // Action for failing to Visibility Decline a user showcase
    case DECLINE_VISIBILITY_SHOWCASE_FAILED:
      return {
        ...state,
        showcase: {
          ...state.showcase,
          loading: false,
          error: action.error,
        },
      }

    default:
      return state;
  }
};

export default showCaseReducer;
